import React, { useState, Fragment, useEffect } from "react";
import { Row, Button, FormGroup, Label, Input, Alert } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Navbarh from "../navbar/Navbar";
import { Storage } from "aws-amplify";//API,
import "../estilos.css";
import { listUsuarios } from "../../graphql/queries";
import {
  createUsuarios as createUsuariosMutation,
  updateUsuarios as updateUsuariosMutation,
} from "../../graphql/mutations";
import Moment from "moment";
import Pagination from "react-js-pagination";
import * as IoIcons from "react-icons/io";
import { GetUsuarios } from "../queries/Queries";
import { getUrl, list, uploadData } from "@aws-amplify/storage";
import { generateClient } from "aws-amplify/api";

const API = generateClient();
//Variables que almacenan los datos del los usuarios
const initialFormState = {
  usuario: "",
  nombreCompleto: "",
  correo: "",
  perfil: "",
  activo: true,
  Almacen: false,
  Clientes: false,
  Cotizaciones: false,
  Planeacion: false,
  Productos: false,
  Metricas: false,
  MarcarEmbarcadoAlmacen: false,
  MarcarEmbarcadoEmbarques: false,
  MarcarFueradePlanta: false,
  PaginaInicial: "",
  VerPrecioUnitario: false,
  Facturacion: false,
  AgregarProvedores: false,
  AutorizarProvedores: false,
  Compras: false,
  LevantarRequisicion: false,
  AutorizarRequisicion: false,
  AutorizarCompra: false,
  Reciba: false,
  PProduccion: false,
  Produccion: false,
  Cuarentena: false,
  AlmacenDInventario: false,
  EmbarquesDInventario: false,
  ProduccionInspeccion: false,
  ProduccionRecuperacion: false,
  ProduccionCalidad: false,
  InspeccionUnicaCalidad: false,
  Embarques: false,
  Ubicacion: false,
  TicketsUsuarios: false,
  TicketsSoporte: false,
  Usuarios: false,
  AutorizarCalidad: false,
  AutorizarEmbarques: false,
  ResumenOperacionVer: false,
  ResumenOperacionEDefectos: false,
  ResumenOperacionEPLaboratorio: false,
  ResumenOperacionEAusentismoP: false,
  ResumenOperacionEDatosExtra: false,
  //PlaneacionAutNoFIFO: false,
  //PlaneacionSinFIFO: false,
  ProduccionCargaManual: false,
  //PProduccionAutNoFIFO1: false,
  //PProduccionAutNoFIFO2: false,
  ProduccionReporteSema: false,
  verPlaneacion: false,
  verPlaneacionBase: false,
  verPlanProduccion: false,
  verEmbarques: false,
  AutorizarTodo: false,
  Reg_Ins_Usuario: "",
  Reg_Mod_Usuario: "",
};

const initialfFormState = { formType: "Usuarios" };
function Usuarios() {
  //Declaración de variables
  const [usuarios, setUsuarios] = useState([]);
  const [mUsuarios, setMUsuarios] = useState([]);
  const [formState, updateFormState] = useState(initialfFormState);
  const [formData, updateFormData] = useState(initialFormState);
  const [isDisabled, setisDisabled] = useState(false);
  const [guardarDisable, setGuardarDisabled] = useState(false);
  const { formType } = formState;
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const userName = window.$name;
  const ppusuarios = window.$Usuarios ? window.$Usuarios : false;
  const [imagen, setImagen] = useState([]);
  const [imagenRepetida, setImagenRepetida] = useState(true);
  const [editarImagen, setEditarImagen] = useState(false);
  const [aVisible, setAVisible] = useState(false);
  const onDismiss = () => setAVisible(false);

  //Método useEffect
  useEffect(() => {
    fetchUsuarios();
  }, []);

  //Obtiene los datos guardados de los clientes
  async function fetchUsuarios() {
    const apiData = await GetUsuarios();
    const usuariosFromAPI = apiData.sort((a, b) =>
      a.usuario > b.usuario ? 1 : a.usuario < b.usuario ? -1 : 0
    );
    await Promise.all(
      usuariosFromAPI.map(async (usuario) => {
        if (usuario.image) {
          const image = await getUrl({ key: usuario.image });//await Storage.get(usuario.image);
          usuario.imagename = usuario.image;
          usuario.image = image.url.toString();
        }
        return usuario;
      })
    );
    setUsuarios(usuariosFromAPI);
  }

  function pUsuarios() {
    setisDisabled(false);
    updateFormData(initialFormState);
    updateFormState(() => ({ ...formState, formType: "Usuarios" }));
  }
  function nuevoUsuario() {
    setGuardarDisabled(false);
    setAVisible(false);
    updateFormState(() => ({ ...formState, formType: "Nuevo Usuario" }));
  }
  function clicEditar(usuario) {
    setAVisible(false);
    setGuardarDisabled(false);
    updateFormData({ ...usuario, Reg_Mod_Usuario: userName });
    setMUsuarios({ ...usuario, Reg_Mod_Usuario: userName });
    updateFormState(() => ({ ...formState, formType: "Editar Usuario" }));
  }
  //Revisa cambios en los inputs
  function onChanges(e) {
    e.persist();
    if (e.target.name === "usuario")
      updateFormData(() => ({
        ...formData,
        [e.target.name]: e.target.value.toUpperCase(),
      }));
    else updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));
  }
  function onChangesCheck(e) {
    e.persist();
    updateFormData(() => ({ ...formData, [e.target.name]: e.target.checked }));
  }

  //Guarda la imagen seleccionada
  async function onChangeimage(e) {
    setMensajeAlert("Revisando si la imagen ya existe");
    setColor("primary");
    setAVisible(true);
    window.scrollTo(0, 0);
    setImagenRepetida(true);
    setGuardarDisabled(true);
    if (!e.target.files[0]) {
      setImagenRepetida(false);
      setGuardarDisabled(false);
      setAVisible(false);
      return;
    }
    const file = e.target.files[0];
    const imageexist = await list({ path: "public/" + file.name });
    if (imageexist.items.length === 0) {
      setImagenRepetida(false);
      setGuardarDisabled(false);
      setAVisible(false);
      setEditarImagen(true);
      setImagen(file);
      updateFormData({ ...formData, image: file.name });
    } else {
      setImagenRepetida(true);
      setMensajeAlert(
        "Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo: "
      );
      setColor("warning");
      setAVisible(true);
      window.scrollTo(0, 0);
    }
  }
  //Guarda los datos de los usuarios
  async function createUsuarios() {
    setAVisible(false);
    setGuardarDisabled(true);
    try {
      delete formData.imagename;
      formData.Reg_Ins_Usuario = userName;
      if (
        !formData.usuario ||
        !formData.nombreCompleto ||
        !formData.correo ||
        !formData.activo
      ) {
        setMensajeAlert(
          "Faltan datos: los campos marcados con un astirisco son obligatorios"
        );
        setColor("warning");
        setAVisible(true);
        window.scrollTo(0, 0);
        setGuardarDisabled(false);
      } else {
        if (imagen.name) {
          await uploadData({ key: imagen.name, data: imagen });
        }
        await API.graphql({
          query: createUsuariosMutation,
          variables: { input: formData },
        });
        if (formData.image) {
          const image = await getUrl({ key: formData.image });//await Storage.get(formData.image);
          formData.image = image.url.toString();
        }
        setMensajeAlert("Datos guardados");
        setColor("primary");
        setAVisible(true);
        setUsuarios([...usuarios, formData]);
        updateFormData(initialFormState);
        updateFormState(() => ({ ...formState, formType: "Usuarios" }));
      }
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert(
        "No fue posible realizar la operación: favor de comunicarse a sistemas"
      );
      setColor("warning");
      setAVisible(true);
      setGuardarDisabled(false);
    }
  }
  //Actualiza los datos de los usuarios
  async function updateUsuarios() {
    setAVisible(false);
    setGuardarDisabled(true);
    try {
      if (
        !formData.usuario ||
        !formData.nombreCompleto ||
        !formData.correo ||
        !formData.activo
      ) {
        setMensajeAlert(
          "Faltan datos: los campos marcados con un asterisco son obligatorios"
        );
        setColor("warning");
        setAVisible(true);
        window.scrollTo(0, 0);
        setGuardarDisabled(false);
      } else {
        if (mUsuarios !== formData) {
          delete formData.createdAt;
          delete formData.updatedAt;
          delete formData.__typename;
          delete formData.imagename;
          if (!editarImagen) delete formData.image;
          else await uploadData({ key: imagen.name, data: imagen });//await Storage.put(imagen.name, imagen);

          await API.graphql({
            query: updateUsuariosMutation,
            variables: { input: formData },
          });
          if (formData.image) {
            const image = await getUrl({ key: formData.image });//await Storage.get(formData.image);
            formData.image = image.url.toString();
          }
          setMensajeAlert("Datos guardados");
          setColor("primary");
          setAVisible(true);
          setEditarImagen(false);
          setUsuarios([...usuarios, formData]);
          updateFormData(initialFormState);
          fetchUsuarios();
          updateFormState(() => ({ ...formState, formType: "Usuarios" }));
        } else {
          setMensajeAlert("No se detectaron cambios");
          setColor("primary");
          setAVisible(true);
          setEditarImagen(false);
          setUsuarios([...usuarios, formData]);
          updateFormData(initialFormState);
          fetchUsuarios();
          updateFormState(() => ({ ...formState, formType: "Usuarios" }));
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      setEditarImagen(false);
      //updateFormData(initialFormState);
      setMensajeAlert(
        "No fue posible realizar la operación: favor de comunicarse a sistemas"
      );
      setColor("warning");
      setAVisible(true);
      setGuardarDisabled(false);
    }
  }
  return (
    <>
      <Navbarh />
      {ppusuarios == true && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoIosContacts
                className="iconoc floatleft"
                onClick={pUsuarios}
              />
              <h3>{formType}</h3>
            </div>
          </Row>
          {
            <div className="conteiner3">
              <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                {mensajeAlert}
              </Alert>
              {formType === "Usuarios" && (
                <Fragment>
                  <Row>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left  ">
                      <button
                        class="cbutton btn-success margintop20px ml-3"
                        onClick={nuevoUsuario}
                      >
                        {" "}
                        <span class="fa fa-plus"> Agregar Usuario</span>{" "}
                      </button>
                    </div>
                  </Row>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                    <Table className="margintop20px mb-2 scroll ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>#</Th>
                          <Th>Usuario</Th>
                          <Th>Correo</Th>
                          <Th>Perfil</Th>
                          <Th className="minwidth80px">Avatar</Th>
                          <Th>Permisos</Th>
                          <Th className="width30px"> Editar </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {usuarios.map((usuario, i) => (
                          <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                            <Td>{i + 1}</Td>
                            <Td>{usuario.usuario}</Td>
                            <Td className="margintopmobil20px">
                              {usuario.correo}
                            </Td>
                            <Td className="margintopmobil20px">
                              {usuario.perfil}
                            </Td>
                            <Td className="margintopmobil20px">
                              {usuario.image ? (
                                <img src={usuario.image} width="100px" />
                              ) : (
                                ""
                              )}
                            </Td>
                            <Td className="margintopmobil20px">
                              {usuario.Administrar ? (
                                <>
                                  Administrar <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Almacen ? (
                                <>
                                  Almacén <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.MarcarEmbarcadoAlmacen ? (<>Marcar embarcado almacén <br /></>) : ("")}
                              {usuario.MarcarFueradePlanta ? (<>Marcar material fuera de planta <br /></>) : ("")}
                              {usuario.AlmacenDInventario ? (
                                <>
                                  Descargar inventario de almacén <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Cuarentena ? (
                                <>
                                  Cuarentena <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Clientes ? (
                                <>
                                  Clientes <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Cotizaciones ? (
                                <>
                                  Cotizaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.CotizacionesAutorizar ? (
                                <>
                                  Autorizar cotizaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Planeacion ? (
                                <>
                                  Planeación <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.verPlaneacion ? (
                                <>
                                  Ver planeación <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.verPlaneacionBase ? (
                                <>
                                  Ver planeación base <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.AgregarComentariosPPB ? (
                                <>
                                  Comentarios de producción en PB <br />
                                </>
                              ) : (
                                ""
                              )}
                              {/*usuario.PlaneacionSinFIFO ? (
                                <>
                                  Planeación sin revisar FIFO <br />
                                </>
                              ) : (
                                ""
                              )*/}
                              {usuario.Productos ? (<>Productos <br /></>) : ("")}
                              {usuario.VerPrecioUnitario ? (<>Ver precio unitario <br /></>) : ("")}
                              {usuario.Facturacion ? (<>Facturación <br /></>) : ("")}
                              {usuario.Compras ? (<>Compras <br /></>) : ("")}
                              {usuario.AgregarProvedores ? (<>Agregar proveedores <br /></>) : ("")}
                              {usuario.AutorizarProvedores ? (<>Autorizar proveedores <br /></>) : ("")}
                              {usuario.LevantarRequisicion ? (<>Levantar requisición <br /></>) : ("")}
                              {usuario.AutorizarRequisicion ? (<>Autorizar requisición <br /></>) : ("")}
                              {usuario.AutorizarCompra ? (<>Autorizar compra <br /></>) : ("")}
                              {usuario.Metricas ? (<>Métricas <br /></>) : ("")}
                              {usuario.Reciba ? (<>Reciba <br /></>) : ("")}
                              {usuario.ModificarCantidadR ? (<>Modificar cantidad de reciba <br /></>) : ("")}
                              {usuario.RecibaDescargar ? (<>Descargar datos de Reciba <br /></>) : ("")}
                              {usuario.PProduccion ? (
                                <>
                                  Plan de producción <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.verPlanProduccion ? (
                                <>
                                  Ver plan de producción <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Produccion ? (
                                <>
                                  Producción <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ProduccionInspeccion ? (
                                <>
                                  Producción Inspección <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ProduccionCalidad ? (
                                <>
                                  Producción Calidad <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.InspeccionUnicaCalidad ? (
                                <>
                                  Producción una sola Inspección <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ProduccionCargaManual ? (
                                <>
                                  Producción carga manual <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ProduccionRecuperacion ? (
                                <>
                                  Recuperación <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Embarques ? (
                                <>
                                  Embarques <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.MarcarEmbarcadoEmbarques ? (<> Marcar embarcado embarques <br /></>) : ("")}
                              {usuario.EmbarquesDInventario ? (
                                <>
                                  Descargar inventario de embarques <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.verEmbarques ? (
                                <>
                                  Ver embarques <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Incoming ? (
                                <>
                                  Incoming <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.IncomingDescarga ? (<>Descargar datos de Incoming <br /></>) : ("")}
                              {usuario.Notificaciones ? (
                                <>
                                  Notificaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.TicketsUsuarios ? (
                                <>
                                  Crear tickets <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.TicketsSoporte ? (
                                <>
                                  Atender tickets <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.TicketsAuditor ? (
                                <>
                                  Auditar tickets <br />
                                </>
                              ) : (
                                ""
                              )}
                              {/*usuario.PlaneacionAutNoFIFO ? (
                                <>
                                  Planeacion autorizar NOFIFO <br />
                                </>
                              ) : (
                                ""
                              )*/}
                              {usuario.AutorizarCalidad ? (
                                <>
                                  Autorizaciones de Calidad<br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.AutorizarEmbarques ? (
                                <>
                                  Autorizaciones Embarques <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ResumenOperacionVer ? (
                                <>
                                  Ver resumen de operaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ResumenOperacionEDefectos ? (
                                <>
                                  Editar defectos de resumen de operaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ResumenOperacionEPLaboratorio ? (
                                <>
                                  Editar datos de laboratorio de resumen de operaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ResumenOperacionEAusentismoP ? (
                                <>
                                  Editar ausentismo de personal de resumen de operaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ResumenOperacionEDatosExtra ? (
                                <>
                                  Editar datos extra de resumen de operaciones <br />
                                </>
                              ) : (
                                ""
                              )}
                              {/*usuario.PProduccionAutNoFIFO1 ? (
                                <>
                                  Plan de producción autorizar NOFIFO1 <br />
                                </>
                              ) : (
                                ""
                              )*/}
                              {/*usuario.PProduccionAutNoFIFO2 ? (
                                <>
                                  Plan de autorizar producción NOFIFO2 <br />
                                </>
                              ) : (
                                ""
                              )*/}
                              {usuario.AutorizarTodo ? (
                                <>
                                  Autorizar todo <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.ProduccionReporteSema ? (
                                <>
                                  Reporte semanal de producción <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Ubicacion ? (
                                <>
                                  Ubicación del material <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.GestionarUbicacion ? (
                                <>
                                  Gestionar ubicación <br />
                                </>
                              ) : (
                                ""
                              )}
                              {usuario.Usuarios ? (
                                <>
                                  Usuarios <br />
                                </>
                              ) : (
                                ""
                              )}

                            </Td>
                            <Td className="margintopmobil40px">
                              <button
                                class="btn-info cbutton mt-1 ml-1"
                                onClick={() => clicEditar(usuario)}
                                title="Editar"
                              >
                                {" "}
                                <IoIcons.IoIosCreate />{" "}
                              </button>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </div>
                </Fragment>
              )}
            </div>
          }
          <div className="conteiner5">
            {formType === "Nuevo Usuario" && (
              <Fragment>
                <Row>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <Label className="floatleft">Usuario*: </Label>
                    <Input
                      name="usuario"
                      value={formData.usuario}
                      placeholder="Nombre de usuario"
                      onChange={onChanges}
                      autoFocus
                    />
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <Label className="floatleft">Nombre completo*: </Label>
                    <Input
                      name="nombreCompleto"
                      placeholder="Nombre completo del usuario"
                      onChange={onChanges}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Correo*:</Label>
                      <Input
                        name="correo"
                        placeholder="Correo institucional del usuario"
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label for="activo" className="floatleft">
                        Activo*
                      </Label>
                      <select
                        name="activo"
                        id="activo"
                        className="activofloat custom-select"
                        onChange={onChanges}
                      >
                        <option value="true">Sí</option>
                        <option value="false">No</option>
                      </select>
                    </FormGroup>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft">Perfil:</Label>
                      <select
                        name="perfil"
                        id="activo"
                        className="activofloat custom-select"
                        onChange={onChanges}
                      >
                        <option value="">Elige una opción</option>
                        <option value="Administrador">Administrador</option>
                        <option value="RH">RH</option>
                        <option value="Mantenimiento">Mantenimiento</option>
                        <option value="Calidad">Calidad</option>
                        <option value="Reciba">Reciba</option>
                        <option value="Produccion">Producción</option>
                        <option value="Embarques">Embarques</option>
                        <option value="Procesos">Procesos</option>
                        <option value="Facturación">Facturación</option>
                        <option value="Compras">Compras</option>
                      </select>
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label for="PaginaInicial" className="floatleft">
                        Página de inicio:
                      </Label>
                      <select
                        name="PaginaInicial"
                        id="PaginaInicial"
                        className="activofloat custom-select"
                        onChange={onChanges}
                      >
                        <option value="">Elige una opción</option>
                        <option value="/administrar">Administrar </option>
                        <option value="/metricas">Métricas</option>
                        <option value="/calidad">Calidad </option>
                        <option value="/clientes">Clientes </option>
                        <option value="/cotizaciones"> Cotizaciones</option>
                        <option value="/productos">Productos </option>
                        <option value="/reciba">Reciba </option>
                        <option value="/almacen">Almacén </option>
                        <option value="/ubicacion">Ubicación del material </option>
                        <option value="/planeacion">Planeación </option>
                        <option value="/planeacionb">Planeación base </option>
                        <option value="/pproduccion">Producción </option>
                        <option value="/embarques">Embarques </option>
                        <option value="/facturacion">Facturación </option>
                        <option value="/compras">Compras </option>
                        <option value="/tickets">Atención a usuarios </option>
                        <option value="/usuarios">Usuarios </option>
                      </select>
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Avatar del Usuario</Label>
                      {<Input type="file" onChange={onChangeimage} />}
                    </FormGroup>
                  </div>
                </Row>
                <Row>
                  <h5 className="floatleft margintop20px">
                    Módulos y permisos
                  </h5>
                </Row>
                <Row className="">
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Almacen"
                        class="form-check-input "
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label " for="exampleCheck1">
                        Almacén
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="MarcarEmbarcadoAlmacen"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Marcar embarcado almacén
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="MarcarFueradePlanta"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Marcar material fuera de planta
                      </label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AlmacenDInventario"
                        class="form-check-input "
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label " for="exampleCheck1">
                        Descargar inventario de almacén
                      </label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Administrar"
                        class="form-check-input "
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label " for="exampleCheck1">
                        Administrar
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Cuarentena"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Cuarentena
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Clientes"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Clientes
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Cotizaciones"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Cotizaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="CotizacionesAutorizar"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar cotizaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verEmbarques"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Embarques"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="MarcarEmbarcadoEmbarques"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Marcar embarcado embarques
                      </label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="EmbarquesDInventario"
                        class="form-check-input "
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label " for="exampleCheck1">
                        Descargar inventario de embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Incoming"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Incoming
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="IncomingDescarga"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Descargar datos de Incoming
                      </label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Notificaciones"
                        class="form-check-input "
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label " for="exampleCheck1">
                        Notificaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Planeacion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Planeación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verPlaneacion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver planeación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verPlaneacionBase"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver planeación base
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AgregarComentariosPPB"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Comentarios de producción en PB
                      </label>
                    </div>
                  </div>
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PlaneacionSinFIFO"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Planeación sin revisar FIFO
                      </label>
                    </div>
                  </div>*/}
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PProduccion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Plan de producción
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verPlanProduccion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver plan de producción
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Produccion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionCalidad"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción Calidad
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="InspeccionUnicaCalidad"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción una sola inspección
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionCargaManual"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción carga manual
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionInspeccion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción Inspección
                      </label>
                    </div>
                  </div>

                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionRecuperacion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Recuperación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarTodo"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar todo
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarCalidad"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizaciones de Calidad
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarEmbarques"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizaciones de Embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionVer"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEDefectos"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar defectos de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEPLaboratorio"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar datos de laborotario de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEAusentismoP"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar ausentismo de personal de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEDatosExtra"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar datos extra de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PlaneacionAutNoFIFO"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar NOFIFO en Planeación
                      </label>
                    </div>
                  </div>*/}
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PProduccionAutNoFIFO1"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar NOFIFO-1 en Producción
                      </label>
                    </div>
                  </div>*/}

                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PProduccionAutNoFIFO2"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar NOFIFO-2 en Producción
                      </label>
                    </div>
                  </div>*/}

                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionReporteSema"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Reporte semanal de produccion
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Productos"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Productos
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="VerPrecioUnitario"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver precio unitario
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Reciba"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Reciba
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ModificarCantidadR"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Modificar cantidad de reciba
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="RecibaDescargar"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Descargar datos de Reciba
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="TicketsAuditor"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Auditar tickets
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="TicketsUsuarios"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Crear tickets
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="TicketsSoporte"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Atender tickets
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Ubicacion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ubicación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="GestionarUbicacion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Gestionar ubicación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Usuarios"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Usuarios
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Facturacion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Facturación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Metricas"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Métricas
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Compras"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Compras
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AgregarProvedores"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Agregar proveedores
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarProvedores"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar proveedores
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="LevantarRequisicion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Levantar requisición
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarRequisicion"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar requisición
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarCompra"
                        class="form-check-input"
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar compra
                      </label>
                    </div>
                  </div>

                </Row>
                {/*<div style={{ marginTop: 20 }}>{JSON.stringify(formData)}</div>*/}
                <div className="margintop20px">
                  <Button
                    className="floatright "
                    onClick={pUsuarios}
                    color="danger"
                  >
                    Cancelar
                  </Button>
                  <Button
                    className="floatright "
                    onClick={createUsuarios}
                    disabled={guardarDisable}
                    color="primary"
                  >
                    Guardar
                  </Button>
                </div>
              </Fragment>
            )}
            {formType === "Editar Usuario" && (
              <Fragment>
                <Row>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <Label className="floatleft">Usuario*: </Label>
                    <Input
                      name="usuario"
                      value={formData.usuario}
                      placeholder="Nombre de usuario"
                      onChange={onChanges}
                      autoFocus
                    />
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <Label className="floatleft">Nombre completo*: </Label>
                    <Input
                      name="nombreCompleto"
                      value={formData.nombreCompleto}
                      placeholder="Nombre completo del usuario"
                      onChange={onChanges}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Correo*:</Label>
                      <Input
                        name="correo"
                        value={formData.correo}
                        placeholder="Correo institucional del usuario"
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label for="activo" className="floatleft">
                        Activo*
                      </Label>
                      <select
                        name="activo"
                        id="activo"
                        className="activofloat custom-select"
                        onChange={onChanges}
                      >
                        <option
                          value="true"
                          selected={formData.activo == true ? true : false}
                        >
                          Sí
                        </option>
                        <option
                          value="false"
                          selected={formData.activo === true ? false : true}
                        >
                          No
                        </option>
                      </select>
                    </FormGroup>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft">Perfil:</Label>
                      <select
                        name="perfil"
                        id="activo"
                        className="activofloat custom-select"
                        onChange={onChanges}
                      >
                        <option value="">Elige una opción</option>
                        <option
                          value="Administrador"
                          selected={
                            formData.perfil == "Administrador" ? true : false
                          }
                        >
                          Administrador
                        </option>
                        <option
                          value="RH"
                          selected={formData.perfil == "RH" ? true : false}
                        >
                          RH
                        </option>
                        <option
                          value="Mantenimiento"
                          selected={
                            formData.perfil == "Mantenimiento" ? true : false
                          }
                        >
                          Mantenimiento
                        </option>
                        <option
                          value="Calidad"
                          selected={formData.perfil == "Calidad" ? true : false}
                        >
                          Calidad
                        </option>
                        <option
                          value="Reciba"
                          selected={formData.perfil == "Reciba" ? true : false}
                        >
                          Reciba
                        </option>
                        <option value="Produccion">Producción</option>
                        <option
                          value="Embarques"
                          selected={
                            formData.perfil == "Embarques" ? true : false
                          }
                        >
                          Embarques
                        </option>
                        <option value="Procesos" selected={formData.perfil == "Procesos" ? true : false}>Procesos</option>
                        <option value="Facturación" selected={formData.perfil == "Facturación" ? true : false}>Facturación</option>
                        <option value="Compras" selected={formData.perfil == "Compras" ? true : false}>Compras</option>
                      </select>
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label for="PaginaInicial" className="floatleft">
                        Página de inicio:
                      </Label>
                      <select
                        name="PaginaInicial"
                        id="PaginaInicial"
                        className="activofloat custom-select"
                        onChange={onChanges}
                      >
                        <option value="">Elige una opción</option>
                        <option value="/administrar" selected={formData.PaginaInicial == "/administrar" ? true : false}>Administrar </option>
                        <option value="/metricas" selected={formData.PaginaInicial == "/metricas" ? true : false}>Métricas</option>
                        <option value="/calidad" selected={formData.PaginaInicial == "/calidad" ? true : false}>Calidad </option>
                        <option value="/clientes" selected={formData.PaginaInicial == "/clientes" ? true : false}>Clientes </option>
                        <option value="/cotizaciones" selected={formData.PaginaInicial == "/cotizaciones" ? true : false}> Cotizaciones</option>
                        <option value="/productos" selected={formData.PaginaInicial == "/productos" ? true : false}>Productos </option>
                        <option value="/reciba" selected={formData.PaginaInicial == "/reciba" ? true : false}>Reciba </option>
                        <option value="/almacen" selected={formData.PaginaInicial == "/almacen" ? true : false}>Almacén </option>
                        <option value="/ubicacion" selected={formData.PaginaInicial == "/ubicacion" ? true : false}>Ubicación del material </option>
                        <option value="/planeacion" selected={formData.PaginaInicial == "/planeacion" ? true : false}>Planeación </option>
                        <option value="/planeacionb" selected={formData.PaginaInicial == "/planeacionb" ? true : false}>Planeación base </option>
                        <option value="/pproduccion" selected={formData.PaginaInicial == "/pproduccion" ? true : false}>Producción </option>
                        <option value="/embarques" selected={formData.PaginaInicial == "/embarques" ? true : false}>Embarques </option>
                        <option value="/facturacion" selected={formData.PaginaInicial == "/facturacion" ? true : false}>Facturación </option>
                        <option value="/compras" selected={formData.PaginaInicial == "/compras" ? true : false}>Compras </option>
                        <option value="/tickets" selected={formData.PaginaInicial == "/tickets" ? true : false}>Atención a usuarios </option>
                        <option value="/usuarios" selected={formData.PaginaInicial == "/usuarios" ? true : false}>Usuarios </option>
                      </select>
                    </FormGroup>
                  </div>
                  {!editarImagen && (
                    <img
                      src={formData.image}
                      className="margintopmobil20px"
                      width="100"
                      title={formData.imagename}
                    />
                  )}
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                    <FormGroup>
                      <Label className="floatleft ">Avatar del Usuario</Label>
                      {<Input type="file" onChange={onChangeimage} />}
                    </FormGroup>
                  </div>
                </Row>
                <Row>
                  <h5 className="floatleft margintop20px">
                    Módulos y permisos
                  </h5>
                </Row>
                <Row className="">
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Almacen"
                        class="form-check-input "
                        checked={formData.Almacen}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label ">Almacén</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="MarcarEmbarcadoAlmacen"
                        class="form-check-input"
                        checked={formData.MarcarEmbarcadoAlmacen}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Marcar embarcado almacén
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="MarcarFueradePlanta"
                        class="form-check-input"
                        checked={formData.MarcarFueradePlanta}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Marcar material fuera de planta
                      </label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AlmacenDInventario"
                        class="form-check-input "
                        checked={formData.AlmacenDInventario}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label ">Descargar inventario de almacén</label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Administrar"
                        class="form-check-input "
                        checked={formData.Administrar}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label ">Administrar</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Cuarentena"
                        class="form-check-input"
                        checked={formData.Cuarentena}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Cuarentena</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Clientes"
                        class="form-check-input"
                        checked={formData.Clientes}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Clientes</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Cotizaciones"
                        class="form-check-input"
                        checked={formData.Cotizaciones}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Cotizaciones</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="CotizacionesAutorizar"
                        class="form-check-input"
                        checked={formData.CotizacionesAutorizar}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">
                        Autorizar cotizaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verEmbarques"
                        class="form-check-input"
                        checked={formData.verEmbarques}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Embarques"
                        class="form-check-input"
                        checked={formData.Embarques}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="MarcarEmbarcadoEmbarques"
                        class="form-check-input"
                        checked={formData.MarcarEmbarcadoEmbarques}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Marcar embarcado embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="EmbarquesDInventario"
                        class="form-check-input"
                        checked={formData.EmbarquesDInventario}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Descargar inventario de embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Incoming"
                        class="form-check-input"
                        checked={formData.Incoming}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Incoming</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="IncomingDescarga"
                        class="form-check-input"
                        checked={formData.IncomingDescarga}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">
                        Descargar datos de Incoming
                      </label>
                    </div>
                  </div>
                  <div class="  form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12 ">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Notificaciones"
                        class="form-check-input "
                        checked={formData.Notificaciones}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label ">Notificaciones</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Planeacion"
                        class="form-check-input"
                        checked={formData.Planeacion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Planeación</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verPlaneacion"
                        class="form-check-input"
                        checked={formData.verPlaneacion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Ver planeación</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verPlaneacionBase"
                        class="form-check-input"
                        checked={formData.verPlaneacionBase}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Ver planeación base</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AgregarComentariosPPB"
                        class="form-check-input"
                        checked={formData.AgregarComentariosPPB}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Comentarios de producción en PB</label>
                    </div>
                  </div>
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PlaneacionSinFIFO"
                        class="form-check-input"
                        checked={formData.PlaneacionSinFIFO}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">
                        Planeación sin revisar FIFO
                      </label>
                    </div>
                  </div>*/}
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PProduccion"
                        class="form-check-input"
                        checked={formData.PProduccion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Plan de producción
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="verPlanProduccion"
                        class="form-check-input"
                        checked={formData.verPlanProduccion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver plan de producción
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Produccion"
                        class="form-check-input"
                        checked={formData.Produccion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionCalidad"
                        class="form-check-input"
                        checked={formData.ProduccionCalidad}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción Calidad
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="InspeccionUnicaCalidad"
                        class="form-check-input"
                        checked={formData.InspeccionUnicaCalidad}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción una sola inspección
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionCargaManual"
                        class="form-check-input"
                        checked={formData.ProduccionCargaManual}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción carga manual
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionInspeccion"
                        class="form-check-input"
                        checked={formData.ProduccionInspeccion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Producción Inspección
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionRecuperacion"
                        class="form-check-input"
                        checked={formData.ProduccionRecuperacion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Recuperación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarTodo"
                        class="form-check-input"
                        checked={formData.AutorizarTodo}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar todo
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarCalidad"
                        class="form-check-input"
                        checked={formData.AutorizarCalidad}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizaciones de Calidad
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarEmbarques"
                        class="form-check-input"
                        checked={formData.AutorizarEmbarques}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizaciones de Embarques
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionVer"
                        class="form-check-input"
                        checked={formData.ResumenOperacionVer}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ver resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft textaligmenleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEDefectos"
                        class="form-check-input"
                        checked={formData.ResumenOperacionEDefectos}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar defectos de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft textaligmenleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEPLaboratorio"
                        class="form-check-input"
                        checked={formData.ResumenOperacionEPLaboratorio}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar datos de laboratorio de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft textaligmenleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEAusentismoP"
                        class="form-check-input"
                        checked={formData.ResumenOperacionEAusentismoP}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar ausentismo de personal de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft textaligmenleft">
                      <input
                        type="checkbox"
                        name="ResumenOperacionEDatosExtra"
                        class="form-check-input"
                        checked={formData.ResumenOperacionEDatosExtra}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Editar datos extra de resumen de operaciones
                      </label>
                    </div>
                  </div>
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PlaneacionAutNoFIFO"
                        class="form-check-input"
                        checked={formData.PlaneacionAutNoFIFO}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar NOFIFO en Planeación
                      </label>
                    </div>
                  </div>*/}
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PProduccionAutNoFIFO1"
                        class="form-check-input"
                        checked={formData.PProduccionAutNoFIFO1}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar NOFIFO-1 en Producción
                      </label>
                    </div>
                  </div>*/}
                  {/*<div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="PProduccionAutNoFIFO2"
                        class="form-check-input"
                        checked={formData.PProduccionAutNoFIFO2}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar NOFIFO-2 en Producción
                      </label>
                    </div>
                  </div>*/}
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ProduccionReporteSema"
                        class="form-check-input"
                        checked={formData.ProduccionReporteSema}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Reporte semanal de produccion
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Productos"
                        class="form-check-input"
                        checked={formData.Productos}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Productos</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="VerPrecioUnitario"
                        class="form-check-input"
                        checked={formData.VerPrecioUnitario}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Ver precio unitario</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Reciba"
                        class="form-check-input"
                        checked={formData.Reciba}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Reciba</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="ModificarCantidadR"
                        class="form-check-input"
                        checked={formData.ModificarCantidadR}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">
                        Modificar cantidad de reciba
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="RecibaDescargar"
                        class="form-check-input"
                        checked={formData.RecibaDescargar}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">
                        Descargar datos de Reciba
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="TicketsUsuarios"
                        class="form-check-input"
                        checked={formData.TicketsUsuarios}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Crear tickets
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="TicketsAuditor"
                        class="form-check-input"
                        checked={formData.TicketsAuditor}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Auditar tickets
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="TicketsSoporte"
                        class="form-check-input"
                        checked={formData.TicketsSoporte}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Atender tickets
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Ubicacion"
                        class="form-check-input"
                        checked={formData.Ubicacion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Ubicación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="GestionarUbicacion"
                        class="form-check-input"
                        checked={formData.GestionarUbicacion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Gestionar ubicación
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Usuarios"
                        class="form-check-input"
                        checked={formData.Usuarios}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Usuarios</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Facturacion"
                        class="form-check-input"
                        checked={formData.Facturacion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label">Facturación</label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Metricas"
                        class="form-check-input"
                        checked={formData.Metricas}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Métricas
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="Compras"
                        class="form-check-input"
                        checked={formData.Compras}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Compras
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AgregarProvedores"
                        class="form-check-input"
                        checked={formData.AgregarProvedores}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Agregar proveedores
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarProvedores"
                        class="form-check-input"
                        checked={formData.AutorizarProvedores}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar proveedores
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="LevantarRequisicion"
                        class="form-check-input"
                        checked={formData.LevantarRequisicion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Levantar requisición
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarRequisicion"
                        class="form-check-input"
                        checked={formData.AutorizarRequisicion}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar requisición
                      </label>
                    </div>
                  </div>
                  <div class=" form-check margintop20px col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div className="floatleft">
                      <input
                        type="checkbox"
                        name="AutorizarCompra"
                        class="form-check-input"
                        checked={formData.AutorizarCompra}
                        onChange={onChangesCheck}
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Autorizar compra
                      </label>
                    </div>
                  </div>

                </Row>
                {/*<div style={{ marginTop: 20 }}>{JSON.stringify(usuarios)}</div>*/}
                <div className="margintop20px">
                  <Button
                    className="floatright "
                    onClick={pUsuarios}
                    color="danger"
                  >
                    Cancelar
                  </Button>
                  <Button
                    className="floatright "
                    onClick={updateUsuarios}
                    disabled={guardarDisable}
                    color="primary"
                  >
                    Guardar
                  </Button>
                </div>
              </Fragment>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Usuarios;
